module.exports = __webpack_public_path__ + "img/in-stock-color.d57301fa.png";